import "./AboutTop.scss";
import React from 'react';
import { FiBarChart2, FiInfo, FiAlertCircle   } from 'react-icons/fi';
import { LuDot } from "react-icons/lu";
import { BsDot } from "react-icons/bs";
import { FaSync, FaPlus, FaEdit, FaTrash, FaSave, FaEye, FaSearch, FaDownload, 
    FaUpload, FaCopy, FaPen, FaArrowLeft, FaArrowRight, FaSignInAlt, FaUserPlus, 
    FaBan, FaChevronLeft, FaChevronRight, FaFileAlt, 
    FaChartBar, FaSpinner, FaPaperPlane, FaCheck, FaCheckCircle, FaMinus } from 'react-icons/fa';




const AboutTop = () => {


return (
    <section className="aboutTop">
    <div className="container">
        <div className="topGrid">
        <div className="topCopy">
            {/* <div className="badge1">GIST Official Student Ambassadors</div> */}
            <h1 className="title">지온나래란?</h1>
            <p className="subtitle">
            지온나래는 광주과학기술원(GIST)의 <b>공식 학생홍보대사</b>로,
            캠퍼스 투어와 교내·외 행사 지원, 그리고 학생이 직접 만드는 정보 콘텐츠를 통해
            GIST의 매력을 전달합니다.
            </p>
            <div className="chips">
            <span className="chip">캠퍼스 투어</span>
            <span className="chip">행사 지원</span>
            <span className="chip">콘텐츠 제작</span>
            </div>
        </div>

        <div className="topPanel">
            <div className="panelTitle">한눈에 보기</div>
            <div className="stats">
            <div className="stat">
                <div className="statLabel">학교의 공식 채널과 연계해 캠퍼스 투어·행사 지원·정보 콘텐츠 제작을 수행합니다.</div>
                <div className="statValue">GIST 공식 학생홍보대사</div>
            </div>
            <div className="stat">
                <div className="statLabel">신입생/재학생이 실제로 궁금해하는 주제를 친근하고 정확하게 정리해 공유합니다.</div>
                <div className="statValue">학생이 직접 만드는 정보 콘텐츠</div>
            </div>
            <div className="stat">
                <div className="statLabel">기획·제작·운영을 함께 경험하며, 실무형 협업 역량을 쌓을 수 있습니다.</div>
                <div className="statValue">팀 단위로 성장하는 활동</div>
            </div>
            </div>
            <div className="panelHint">
                    <BsDot /> 활동은 "공식"이지만, 콘텐츠는 "친근하게" 만드는 것을 목표로 합니다.
            </div>
        </div>
        </div>
    </div>
    </section>
);
};

export default AboutTop;